<template>
  <div id="app" class="min-h-screen bg-gray-50 flex flex-col">
    <Navbar v-if="isAuthenticated" @openContact="showContactModal = true" />
    <main class="flex-grow">
      <router-view />
    </main>
    <footer class="bg-white border-t border-gray-200 py-4">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col items-center gap-3">
          <!-- EULA Disclaimer -->
          <p class="text-xs text-gray-500 text-center">
            By creating an account you are accepting our 
            <button 
              @click="showEulaModal = true" 
              class="text-purple-600 hover:text-purple-800 underline font-medium"
            >
              End User License Terms
            </button>.
          </p>
          
          <div class="flex flex-col sm:flex-row items-center justify-between gap-2 w-full">
            <p class="text-sm text-gray-500">
              © {{ currentYear }} <span class="font-semibold bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent">QRKY</span>. All rights reserved.
            </p>
            <button
              @click="showContactModal = true"
              class="text-sm text-purple-600 hover:text-purple-800 font-medium flex items-center gap-1 transition-colors"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </footer>
    
    <!-- Contact Modal -->
    <ContactModal
      :show="showContactModal"
      @close="showContactModal = false"
    />
    
    <!-- EULA Modal -->
    <EulaModal
      :show="showEulaModal"
      @close="showEulaModal = false"
      @accept="showEulaModal = false"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import Navbar from '@/components/Navbar.vue'
import ContactModal from '@/components/ContactModal.vue'
import EulaModal from '@/components/EulaModal.vue'

const authStore = useAuthStore()
const isAuthenticated = computed(() => authStore.isAuthenticated)
const currentYear = computed(() => new Date().getFullYear())
const showContactModal = ref(false)
const showEulaModal = ref(false)

onMounted(() => {
  authStore.initializeAuth()
})
</script>

<style>
@import './assets/main.css';
</style>
